import $ from 'jquery';
const userAgent = window.navigator.userAgent;
const ua = userAgent.toLowerCase();

export const platform = {
  isAndroid: function () {
    return ua.indexOf('android') > -1;
  },
  isIOS: function () {
    return ua.indexOf('iphone') > -1;
  },
  isWinPhone: function () {
    return !!navigator.userAgent.match(/Windows Phone/i);
  },
  isIpad: function () {
    let NPlatform = navigator.platform;
    return (
      /iPad/gi.test(NPlatform) ||
      (NPlatform === 'MacIntel' &&
        navigator.maxTouchPoints > 1 &&
        !window.MSStream)
    );
  },
  isPhone: function () {
    return (
      this.isAndroid() || this.isIOS() || this.isWinPhone() || this.isIpad()
    );
  },
  isIE11: function () {
    return (
      userAgent.indexOf('Trident') > -1 && userAgent.indexOf('rv:11.0') > -1
    );
  },
  isEdge: function () {
    return userAgent.indexOf('Edge') > -1;
  },
};

export const whatDevice = () => {
  if (!platform.isPhone() || platform.isIE11() || platform.isEdge()) {
    return 'pc';
  }
  if (platform.isPhone()) {
    return 'mobile';
  }
};
export const isMobile = () => {
  if (!platform.isPhone() || platform.isIE11() || platform.isEdge()) {
    return false;
  }
  if (platform.isPhone()) {
    return true;
  }
};
export const isIE = () => {
  return platform.isIE11();
};

export const deviceType = () => {
  if (platform.isIOS() || platform.isIpad()) {
    return 'ios';
  }
  if (platform.isAndroid()) {
    return 'android';
  }
};

export const showTips = tip => {
  $('.j-tips').html(tip);
  $('.j-popup').fadeOut();
  $('.j-popup-tip').fadeIn();
};

export function isToday(str) {
  let d = new Date(str.replace(/-/g, "/"));
  let todaysDate = new Date();
  return d.setHours(0, 0, 0, 0) == todaysDate.setHours(0, 0, 0, 0);
}

export const isMobileIos = () => {
  return whatDevice() == "mobile" && deviceType() == "ios";
};

export const compareTime = (startTime, endTime) => {
  let timezone = 7;//目标时区时间，东七区 越泰时间
  let offset_GMT = new Date().getTimezoneOffset();//本地时间和格林威治的时间差，单位为分钟 UTC
  let nowDate = new Date().getTime();//本地时间距1970年1月1日午夜0时（GMT时间）之间的毫秒数
  let targetTime = nowDate + offset_GMT * 60 * 1000 + timezone * 60 * 60 * 1000;//目标时区时间毫秒数
  
  let sTime = new Date(startTime);
  let eTime = new Date(endTime);
  if (targetTime < sTime.getTime()) {
    return -1;
  }
  if (targetTime > eTime.getTime()) {
    return 1;
  }
  return 0;
};